<!-- TileContent.vue -->
<template>
    <div class="tile-content">
        <span class="return" @click="returnHome()"><i class="fa-solid fa-chevron-left" style="padding-right: 10px;"></i>Back</span>
        <!-- Content for a single tile -->        
        <SiteManagementContent v-if="title === 'Sites'" test_text="we have loaded Stock Management"></SiteManagementContent>
        <CryoProcessingContent v-if="title ==='Cryo Processing'" style="margin-top: 20px;" :year="year"></CryoProcessingContent>
        <ReportsContent v-if="title ==='Reports'"></ReportsContent>
        <TasksContent v-if="title ==='Tasks'"></TasksContent>
        <UserManagementContent v-if="title ==='User Management'"></UserManagementContent>
        <DevicesContent v-if="title ==='LifeLink Devices'"></DevicesContent>
    </div>
</template>

<script>

import SiteManagementContent from './SiteManagementContent.vue';
import CryoProcessingContent from './CryoProcessingContent.vue';
import ReportsContent from './ReportsContent.vue';
import TasksContent from './TasksContent.vue';
import UserManagementContent from './UserManagementContent.vue';
import DevicesContent from './DevicesContent.vue';

export default {
    components: { SiteManagementContent, CryoProcessingContent, ReportsContent, TasksContent, UserManagementContent, DevicesContent },
    // You can use props to pass data specific to each tile
    props: {
        title: String,
        description: String,
        year: String,
        // Add more props as needed
    },
    mounted: function () {
        console.log("Title: " + this.title + " Descr: " + this.description);
        console.log("Year: " + this.year);
    },
    methods: {
        returnHome() {
            console.log("go back button clicked");
            // Set the "active tile" to null, effectively going back to the main page
            this.$emit('toggle-back');
        }
    },
};
</script>

<style scoped>
/* Add styles for the content component as needed */
.return {
    color: #0d6efd;
    text-decoration: none;
}

.return:hover {
    text-decoration: underline;
    cursor: pointer;
}
</style>
